export default "__VITE_ASSET__Dq83l5KI__"